import VideoCardHeader from './VideoCardHeader';

export default VideoCardHeader;
